var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-filter")]),
              _vm._v(" Filtros de Busca ")
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Usar filtro padrão (QD)" },
                                on: { change: _vm.onFiltroChange },
                                model: {
                                  value: _vm.usarFiltroPadrao,
                                  callback: function($$v) {
                                    _vm.usarFiltroPadrao = $$v
                                  },
                                  expression: "usarFiltroPadrao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Filtrar por números de título"
                                },
                                on: { change: _vm.onFiltroChange },
                                model: {
                                  value: _vm.usarFiltroNumeros,
                                  callback: function($$v) {
                                    _vm.usarFiltroNumeros = $$v
                                  },
                                  expression: "usarFiltroNumeros"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.usarFiltroNumeros
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              label: "Números de Títulos",
                              placeholder:
                                "Digite os números dos títulos separados por vírgula, enter ou espaço",
                              hint: "Exemplo: 477977/1, 721603/6, 755202/5",
                              rows: "4",
                              outlined: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "v-icon--clearable",
                                          on: {
                                            click: _vm.limparNumerosTitulos
                                          }
                                        },
                                        [_vm._v(" mdi-close-circle ")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              44193994
                            ),
                            model: {
                              value: _vm.numerosTitulos,
                              callback: function($$v) {
                                _vm.numerosTitulos = $$v
                              },
                              expression: "numerosTitulos"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.usarFiltroPadrao && _vm.usarFiltroNumeros
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: { type: "info", outlined: "", dense: "" }
                            },
                            [
                              _c("strong", [_vm._v("Filtros combinados:")]),
                              _vm._v(
                                " Serão buscados títulos que contenham QD na revisão OU que estejam na lista de números informados com status 220 (Solicitado protesto). "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm.usarFiltroPadrao
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: { type: "info", outlined: "", dense: "" }
                            },
                            [
                              _c("strong", [_vm._v("Filtro padrão:")]),
                              _vm._v(
                                " Serão buscados apenas títulos que contenham [QD] na revisão. "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm.usarFiltroNumeros
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                type: "warning",
                                outlined: "",
                                dense: ""
                              }
                            },
                            [
                              _c("strong", [_vm._v("Filtro por números:")]),
                              _vm._v(
                                " Apenas títulos com status 220 da lista informada serão elegíveis. "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loading,
                            disabled: !_vm.podeBuscar
                          },
                          on: { click: _vm.buscarTitulos }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("mdi-magnify")
                          ]),
                          _vm._v(" Buscar Títulos ")
                        ],
                        1
                      ),
                      _vm.titulosElegiveis.length > 0
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                color: "success",
                                disabled: _vm.titulosSelecionados.length === 0
                              },
                              on: { click: _vm.baixarModelo }
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("mdi-download")
                              ]),
                              _vm._v(
                                " Baixar modelo de importação de devedores "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.titulos.length > 0
        ? _c(
            "v-card",
            { staticClass: "mt-4" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "blue", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(_vm._s(_vm.titulos.length))
                                ]),
                                _c("div", [_vm._v("Total de Títulos")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "green", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.titulosElegiveis.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Títulos Elegíveis")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "orange", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.titulosSelecionados.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Selecionados")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { color: "red", dark: "" } },
                            [
                              _c("v-card-text", [
                                _c("div", { staticClass: "text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.titulosInelegiveis.length) +
                                      " "
                                  )
                                ]),
                                _c("div", [_vm._v("Inelegíveis")])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.titulos.length > 0
        ? _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.titulos,
              "item-key": "unique_id",
              "show-select": "",
              loading: _vm.loading,
              "footer-props": {
                itemsPerPageOptions: [50, 100, 200],
                itemsPerPageText: "Itens por página:"
              },
              "loading-text": "Pesquisando títulos...",
              "no-data-text": "Nenhum título encontrado..."
            },
            on: { "toggle-select-all": _vm.onToggleSelectAll },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.data-table-select`,
                  fn: function({ item, isSelected, select }) {
                    return [
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": isSelected,
                          disabled: !item.elegivel,
                          color: "primary"
                        },
                        on: {
                          change: function($event) {
                            return select(!isSelected)
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: `item.id_titulo`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "span",
                        { style: { color: item.elegivel ? "black" : "grey" } },
                        [_vm._v(" " + _vm._s(item.id_titulo) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: `item.ds_nosso_numero`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "span",
                        { style: { color: item.elegivel ? "black" : "grey" } },
                        [_vm._v(" " + _vm._s(item.ds_nosso_numero) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: `item.devedor_principal`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "div",
                        { style: { color: item.elegivel ? "black" : "grey" } },
                        [
                          _c("div", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              " " + _vm._s(item.nm_devedor_principal) + " "
                            )
                          ]),
                          _c("div", { staticClass: "text-caption" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatarDocumento(
                                    item.nu_identificacao_devedor
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ]
                  }
                },
                {
                  key: `item.qtd_devedores_esperada`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color:
                              item.nu_quantidade_devedores > 0
                                ? "blue"
                                : "grey",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.nu_quantidade_devedores || 0) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: `item.qtd_cadastrada`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: item.qtd_cadastrada > 0 ? "green" : "orange",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [_vm._v(" " + _vm._s(item.qtd_cadastrada || 0) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: `item.cd_status`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: _vm.getStatusColor(
                              item.cd_status,
                              item.ds_revisao,
                              item
                            ),
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getStatusText(
                                  item.cd_status,
                                  item.ds_revisao,
                                  item
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: `item.aviso`,
                  fn: function({ item }) {
                    return [
                      item.mensagem_aviso
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { color: "error" } },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-alert-circle ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.mensagem_aviso))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { color: "success" }
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-check-circle ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Título elegível para manutenção em lote"
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.titulosSelecionados,
              callback: function($$v) {
                _vm.titulosSelecionados = $$v
              },
              expression: "titulosSelecionados"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }